import AboutUsView from "../components/Sections/AboutUsView";

export default function AboutUs() {
    return (<AboutUsView />);
}